import React from 'react';
import { Link } from 'react-router-dom';

export default class About extends React.Component {
  render() {
    return(
      <div className='about'>
        <h1>About</h1>
        <p>
          <a href='https://www.linkedin.com/in/jgrahamthomas'>I'm a software engineering manager by day</a>.
          Yak Tack is my diversion. I've long held a fascination with words and have been
          searching for techniques to improve my vocabulary. Often I'd hear a word in conversation, like <Link to='/words/extemporaneous'>extemporaneous</Link>,
          and look it up on Google. A week later I'd hear it again somewhere and forget what it meant.
        </p>
        <h3>Spaced Repetition</h3>
        <p>
          <a href="https://en.wikipedia.org/wiki/Spaced_repetition">Spaced repetition</a> is a learning technique
          that dates back to 1932. When applied to words, it can significantly bolster recall.
          Yak Tack, LLC was formed in July 2018 to help people remember words using this technique.
        </p>
        <h3>The Name</h3>
        <p>
          <b>Yak</b> in "Yak Tack" comes from "yakety-yak," a term that means "noisy talk." And <Link to="/words/tack">tack</Link> refers to "the quality of being sticky." Combined
          we've got a name that means something like "word sticker."
        </p>
        <h1>Expansive Vocabulary = <br />Simpler Communication</h1>
        <p>
          <i>"The difference between the right word and the almost right word is the difference between lightning and a lightning bug."</i>
          <br />–Mark Twain
        </p>
        <p>
          An expansive vocabulary can simplify communication, not make it more complicated as most people might infer.
          It allows people to say what they mean with greater precision.
        </p>
        <p>
          Yak Tack helps people expand their vocabulary.
        </p>
        <h1>How Yak Tack Works</h1>
        <ol>
          <li>
            Type a word you'd like to remember. Or, email word@yaktack.com with the word as the subject.
          </li>
          <li>
            Get an email with the definition at expanding daily intervals. This is where <b>spaced repetition</b> comes in.
            The intervals follow the <a href="https://en.wikipedia.org/wiki/Fibonacci_number">Fibonacci Sequence</a>.
          </li>
          <li>
            During the first few intervals, simply read the email and delete it. With later intervals the email will ask you to pick the right definition. We stop at interval 13.
          </li>
          <li>
            After each interval, the word will be easier to recall when you hear or read it again.
          </li>
        </ol>
        <h1>Pricing</h1>
        <p>
          We have a free and a paid plan.
        </p>
        <h3>Free for One</h3>
        <p>
          $0.00, and we help you remember one word at a time. Other words
          you tack are put in a queue. When you're done remembering a word, we kick off the next one.
        </p>
        <h3>Unlimited</h3>
        <p>
          ${process.env.REACT_APP_SUBSCRIPTION_FEE} per month for unlimited tacks (yeah, it's like the price of an espresso shot). No queues. And we help you
          find your magical limit of concurrent learning which is probably somewhere between 2 and 10 words at a time.
        </p>
        <h1>Contact Us</h1>
        <p>
          Questions? Concerns? Tribulations? Send an email to <b>hello@yaktack.com</b> to get in touch.
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/about.jsx